<script setup lang="ts">
import { VNodeRenderer } from '@layouts/components/VNodeRenderer'
import { themeConfig } from '@themeConfig'
import { computed } from 'vue';
import { useDisplay } from 'vuetify'

import {VForm} from "vuetify/components/VForm";
definePage({
  path:'/',
  meta: {
    layout: 'blank',
    public: true,
    unauthenticatedOnly: true,
  },
})
const errors = ref<Record<string, string | undefined>>({
  email: undefined
})

const { mobile,smAndDown } = useDisplay()
// const route = useRoute('portal')

const datas = ref([])

const grid1Headers =ref([
  { title: '', key: 'isTop', },
  { title: '公告日期', key:'publishDate' ,},
  { title: '標題', key: 'title', },
  
])

const systemsSapmle = [
  { menuId:'TCA', path:'/tca'},
  { menuId:'ATH', path:'/ath'},
  { menuId:'STK', path:'/stk'},
]

const getSystemUrl = (system) => {
  if (!system.path) return undefined
  // 完整 URL 直接回傳
  if (/^https?:\/\//.test(system.path)) {
    return system.path
  }
  // 用 origin 自動適配 dev (http://localhost:3000) 和 prod (https://testeportal.nstc.org.tw)
  return `${window.location.origin}${system.path}`
}

const filter = ref({
  page:1,
  size:3,
})
const totalDatas = ref(0)


const searchBulltins = async() =>{
  try {
    const response = await $api('/bu/bulletin/search', {
      method: 'POST',
      body: {
        date:{
        },
        pageable:{
          page:filter.value.page-1,
          size:filter.value.size,
        },
      },
    })
    totalDatas.value = response.data.numberOfElements
    datas.value.splice(0 , datas.value.length , ...response.data.content)
  } catch (error) {
    totalDatas.value = 0
    datas.value.splice(0 , datas.value.length )
    console.error('Error during fetch:', error);
  }
}



const { data: systemData, execute: getSystems } = await useApi<any>(createUrl('/ds/menu/menu/getSystemList', {
  query: {
    compId:'nstc',
  },
}))
// const systemData = ref([])
const color = '#673AB7'
const colorLight = '#D1C4E9'
const tablerIcon = 'help-hexagon'

const systemsAll = computed(()=>{
  if(systemData.value.length>0){
    return systemData.value.map((item)=>{
      const system = systemsSapmle.find((it)=>item.menuId === it.menuId)
        if(system){
          return { 
            ...item,
            ...system,
          }
        }else{
          return {
            ...item,
            tablerIcon:isEmpty(item.tablerIcon)?tablerIcon:item.tablerIcon,
            color:isEmpty(item.color)?color:item.color,
            colorLight:isEmpty(item.colorLight)?colorLight:item.colorLight,
          }
        }
    })
  }else{
    return  []
  }
})

const ourSystems = computed(()=>{
  return systemsAll.value.filter((item)=>item.menuId == 'ATH'||item.menuId == 'TCA'||item.menuId == 'STK')
})

const otherSystems = computed(()=>{
  return systemsAll.value.filter((item)=>item.menuId !== 'ATH'&&item.menuId !== 'TCA'&&item.menuId !== 'STK')
})

onMounted(()=>{
  searchBulltins()
})


</script>

<template>
  <VContainer fluid  class="h-100vh px-lg-10 px-md-6">
    <slot name="content">
      <VNodeRenderer class="text-center" :nodes="themeConfig.app.logoTstc" />
    </slot> <!-- 可選內容 -->
    <VRow>
      <VCol cols="12" :order="mobile?1:0" v-if="datas.length>0">
        <VCard class="mt-6">
          <VCardItem class="py-3">
            <VCardTitle>系統公告</VCardTitle>
          </VCardItem>
          <VDataTableServer
            v-model:items-per-page="filter.size"
            v-model:page="filter.page"
            :items="datas || []"
            :items-length="totalDatas"
            :headers="grid1Headers"
            class="text-no-wrap "
            no-data-text="尚無系統公告"
            :show-expand="!smAndDown"
          >

          <template v-slot:headers="{ columns, isSorted, getSortIcon, toggleSort }" v-if="smAndDown">
          </template>
          <template v-slot:item.data-table-expand="{ internalItem, isExpanded, toggleExpand }">
            <v-btn
              v-if="!isEmpty(internalItem.raw.content)"
              class="text-none"
              color="medium-emphasis"
              size="small"
              variant="text"
              @click="toggleExpand(internalItem)"
            >
            <v-icon size="12">
              {{isExpanded(internalItem) ? 'tabler-chevron-up' : 'tabler-chevron-down'}}
            </v-icon>
            </v-btn>
          </template>
          <template v-slot:expanded-row="{ columns, item }">
            <tr>
              <td :colspan="columns.length" class="py-2">
                {{item.content}}
              </td>
            </tr>
          </template>
          <template #item.isTop="{ item }">
            <v-icon size="12" v-if="item.isTop=='Y'" color="error">
              tabler-pin
            </v-icon>
          </template>
          <template v-slot:item="{item}" v-if="smAndDown&&datas.length>0">
            <v-divider></v-divider>
              <VListItem>
                <VListItemTitle class="text-h5 font-weight-bold my-1">{{item.title}}</VListItemTitle>
                <VListItemTitle class="text-caption">{{item.content}}</VListItemTitle>
                <VListItemSubtitle class="d-flex justify-space-between">
                  <div class="text-caption">
                    {{item.publishDate}}
                    <v-icon size="12" v-if="item.isTop=='Y'" color="error">
                      tabler-pin
                    </v-icon>
                  </div>
                  <v-dialog max-width="500">
                    <template v-slot:activator="{ props: activatorProps }">
                      <v-btn
                        v-bind="activatorProps"
                        icon
                        size="x-small"
                        color="surface-variant"
                        variant="outlined"
                      >
                        <v-icon size="12">
                          tabler-eye
                        </v-icon>
                      </v-btn>
                    </template>

                    <template v-slot:default="{ isActive }">
                      <v-card >
                        <v-card-text>
                          <div class="text-h5 font-weight-bold">{{item.title}}</div>
                          <br/>
                          <div>{{item.content}}</div>
                        </v-card-text>

                        <v-card-actions>
                          <v-spacer></v-spacer>

                          <v-btn
                            text="關閉"
                            @click="isActive.value = false"
                          ></v-btn>
                        </v-card-actions>
                      </v-card>
                    </template>
                  </v-dialog>

                </VListItemSubtitle>
              </VListItem>
            </template>
            <template #bottom>
              <TablePagination
                v-model:page="filter.page"
                v-model:size="filter.size"
                :items-per-page="filter.size"
                :total-items="totalDatas"
              />
            </template>
          </VDataTableServer>
        </VCard>
      </VCol>
      <VCol cols="12" :order="mobile?0:1">
        <VRow class="mt-5" >
          <VCol v-for="system in ourSystems" :key="system" cols="12" sm="6" md="4">
            <a :href="getSystemUrl(system)" class="system-card-link">
              <VCard
                class="w-100 h-100 custom-border custom-background border-0"
                elevation="4"
                :style="{ borderBlockEndColor: system.color??'#673AB7' }"
              >
                <div class="h-100 py-16 w-100 px-6" :class="mobile?'text-center':'text-left'">
                  <v-avatar
                    :color="system.colorLight??'#D1C4E9'"
                    rounded
                    size="50"
                    class="mb-4"
                  >
                    <v-icon :color="system.color??'#673AB7'" size="30">
                      {{ system.tablerIcon?`tabler-${system.tablerIcon}`:'tabler-help-hexagon' }}
                    </v-icon>
                  </v-avatar>
                  <h1>{{ system.menuDesc }}</h1>
                  <div class="text-left text-body-2 mt-3">{{ system.systemRemark }}</div>
                </div>
              </VCard>
            </a>
          </VCol>
          <VCol v-for="system in otherSystems" :key="system" :cols="otherSystems.length>1?6:12" :sm="otherSystems.length>1?6:12"
            :md="otherSystems.length>6?2:true" :lg="otherSystems.length>6?2:true">
            <a :href="getSystemUrl(system)" class="system-card-link">
              <VCard
                class="w-100 h-100 custom-border custom-background border-0"
                elevation="4"
                :style="{ borderBlockEndColor: system.color??'#673AB7' }"
              >
                <div class="h-100 py-16 w-100 px-6" :class="mobile?'text-center':'text-left'">
                  <v-avatar
                    :color="system.colorLight??'#D1C4E9'"
                    rounded
                    size="50"
                    class="mb-4"
                  >
                    <v-icon :color="system.color??'#673AB7'" size="30">
                      {{ system.tablerIcon?`tabler-${system.tablerIcon}`:'tabler-help-hexagon' }}
                    </v-icon>
                  </v-avatar>
                  <h1>{{ system.menuDesc }}</h1>
                  <div class="text-left text-body-2 mt-3">{{ system.systemRemark }}</div>
                </div>
              </VCard>
            </a>
          </VCol>
        </VRow>
      </VCol>
    </VRow>
  </VContainer>
</template>

<style lang="scss">
// @use "@core/scss/template/pages/page-auth.scss";

.custom-background{
    background: white !important;
}
.custom-border {
  border-block-end-width: 3px !important;
  border-block-end-style: solid !important;
}
.system-card-link {
  text-decoration: none;
  color: inherit;
  display: block;
}
</style>
